<template id="appLogDownload">
  <div id="logDownloadPage">
    <div v-if="downloading">
      <md-progress-spinner md-mode="indeterminate"></md-progress-spinner>
      <p>Downloading {{ filename }}...</p>
    </div>
    <div v-else-if="error">
      <p class="error">{{ error }}</p>
    </div>
    <div v-else>
      <p>Download complete.</p>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";

export default {
  name: "AppLogDownload",
  data: () => ({
    downloading: true,
    error: null,
    filename: "",
  }),
  async created() {
    this.filename = this.$route.params.filename;
    await this.startDownload();
  },
  methods: {
    ...mapActions(["downloadLogFile"]),
    async startDownload() {
      try {
        await this.downloadLogFile(this.filename);
        this.downloading = false;
      } catch (err) {
        this.error = `Failed to download file: ${err.message}`;
        this.downloading = false;
      }
    },
  },
};
</script>
<style scoped>
#logDownloadPage {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
}
.error {
  color: red;
}
</style>
